import AppProviders from './AppProviders'
import ErrorBoundary from '../components/common/ErrorBoundary'
import AppRoutes from '../routes/AppRoutes'
import Branding from '../features/settings/Branding'

export default function App() {
  return (
    <ErrorBoundary>
      <AppProviders>
        <Branding />
        <AppRoutes />
      </AppProviders>
    </ErrorBoundary>
  )
}
